module.exports = __webpack_public_path__ + "img/reporter.cb365679.png";